<template>
    <div class="content">
        <video id ='video' autoplay loop controls >
            <source :src="path"  type="video/mp4">
        </video>
    </div>
</template>

<script>
export default {
    data(){
        return{
            path:"files/demo.mp4"
        }
    },
    created(){
       this.path = this.$route.query.path;
       console.log( this.path)
    }
}
</script>


<style lang="scss" scoped>
    .content{
        width: 100%;
        height: 100vh;
        background-color: black;
        
        display: flex;
        justify-content: center;
        align-items: center;

        #video{
            width: 80%;
            height: 80%;
        }
    }
</style>